import React from "react";
import { makeStyles, Backdrop, Fade, Modal } from "@material-ui/core";

const style = theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

const useStyle = makeStyles(style);
export default function ModalComponent({ isOpen, handleClose, children }) {
  const classes = useStyle();
  return (
    <Modal
      className={classes.root}
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={isOpen} style={{ outline: "none" }}>
        <div>{children}</div>
      </Fade>
    </Modal>
  );
}
